import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { authHttpClient } from '../../../../../core/infra/http/axios-auth-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { CNPJLookup } from './cnpj-lookup';

export const cnpjLookupService: ServiceCommand<CNPJLookup.Response> =
  new CNPJLookup(authHttpClient, AUTH_API_ROUTES.CNPJ_LOOKUP);

export type { CNPJLookup };
